angular.module('iqxCore').controller('AgencyCandidatesCtrl', function ($scope, $q, FormSvc, ApiSvc, QuestionnaireSvc, ApplicationSvc) {
  $scope.checkPermissions('AGENCY')

  FormSvc.setOptions($scope, {
    fetchAPI: 'callresult/NetAgencyCandidates',
    multiRow: true,
    autoEdit: true
  })

  $scope.editCandOld = function (cand) {
    ApplicationSvc.navigate('/canddetails?id=' + cand.PersonID)
  }

  function fetchQuestionnaire(PersonID) {
    return QuestionnaireSvc.fetch($scope, {
      tagTarget: 'tags',
      tagLocation: 'P',
      displayGroup: '?SECAGCAND', // ? Means that if no members of the group, fall back on normal published P questionnaire
      id: PersonID
    })
  }

  function fetchStatusList() {
    if ($scope.StatusList) {
      return $q.when('Already fetched')
    } else {
      return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetAgencyCandidateStatusChoices', fetchTarget: 'StatusList', multiRow: true })
    }
  }

  function StatusDescrip(sID) {
    var rv = ''
    angular.forEach($scope.StatusList, function (x) {
      if (x.ID == sID) {
        rv = x.Description
      }
    })
    return rv
  }

  $scope.editCand = function (cand) {
    var editedDat
    FormSvc.fetch($scope, {
      fetchAPI: 'callresult/netcandidateprofile?pPersonID=' + cand.PersonID,
      fetchTarget: 'candData',
      dateFields: ['DOB']
    })
      .then(function () {
        return fetchQuestionnaire(cand.PersonID)
      })
      .then(function () {
        return fetchStatusList()
      })
      .then(function () {
        return FormSvc.modalForm($scope, 'agencyCandDetails', angular.copy($scope.candData), 'md', false, $scope.tags)
      })
      .then(function (dat) {
        editedDat = dat // Used to update the array after successful save to avoid refresh
        dat = FormSvc.saveableRecord(dat, 'p', 'PersonID', $scope.candData)
        if (!dat) {
          FormSvc.alert('Notice', 'Nothing to save.', 'info')
          return $q.reject('')
        } // Nothing to save
        return $scope.exec('call/netcandidateprofileset', dat)
      })
      .then(function () {
        FormSvc.alert('Updated', 'Candidate has been updated successfully.', 'success')
        cand.CandidateName = FormSvc.getFirstWord(editedDat.Forenames) + ' ' + editedDat.Surname
        cand.CandidateReference = (editedDat.SecondaryAgencyRef || '').toUpperCase()
        cand.CandidateStatus = StatusDescrip(editedDat.SecondaryAgencyCandidateStatus)
      })
  }

  $scope.newCand = function () {
    var newDat
    fetchQuestionnaire()
      .then(function () {
        return fetchStatusList()
      })
      .then(function () {
        var dat = {}
        if ($scope.StatusList.length) {
          // Set first on list as default
          dat.SecondaryAgencyCandidateStatus = $scope.StatusList[0].ID
        }
        return FormSvc.modalForm($scope, 'agencyCandDetails', dat, 'md', false, $scope.tags)
      })
      .then(function (dat) {
        if (!dat) {
          return $q.reject('')
        } // Dialog closed with x button
        newDat = dat // In outer scope for later use
        return $scope.exec('call/NetAgencyCandidateCreate', { pSurname: newDat.Surname, pForenames: newDat.Forenames })
      })
      .then(function (res) {
        newDat.PersonID = res.IQXResult.IQXSuccess.attrs.id
        return $scope.exec('call/netcandidateprofileset', FormSvc.saveableRecord(newDat, 'p'))
      })
      .then(function () {
        FormSvc.alert('Success', 'Your new candidate has been created successfully.', 'success')
        $scope.theRecords.push({
          PersonID: newDat.PersonID,
          CandidateName: FormSvc.getFirstWord(newDat.Forenames) + ' ' + newDat.Surname,
          CandidateReference: (newDat.SecondaryAgencyRef || '').toUpperCase(),
          CandidateStatus: StatusDescrip(newDat.SecondaryAgencyCandidateStatus)
        })
      })
  }

  $scope.candDocs = function (cand) {
    ApplicationSvc.navigate('/agencydocuments?id=' + cand.PersonID)
  }

  $scope.candCompliance = function (cand) {
    ApplicationSvc.navigate('/agencycompliance?id=' + cand.PersonID)
  }

  $scope.fetch()
})
